import type { IAlert } from 'types/alert';
import type { TProduct } from 'types/product';

export const WISHLIST_ITEMS_PER_PAGE = 12;

export const ALERT_COMMON_CONFIG: Pick<IAlert, 'isCentered' | 'variation' | 'autohide'> = {
  isCentered: true,
  variation: 'toast',
  autohide: true,
};

export const sortOutOfStockProducts = (products: TProduct[]): TProduct[] => {
  if (!products) {
    return [];
  }

  const outOfStockProducts = products.filter(product => product.buyBox[0].stock === 0);
  const inStockProducts = products.filter(product => product.buyBox[0].stock !== 0);
  return inStockProducts.concat(outOfStockProducts);
};

export const getTotalPages = (itemsPerPage: number, products: TProduct[]): number =>
  Math.ceil(products.length / itemsPerPage);

export const handleProductsInPage = (
  itemsPerPage: number,
  page: number,
  products: TProduct[]
): TProduct[] => products?.slice((page - 1) * itemsPerPage, page * itemsPerPage);

export const WISHLIST_ORDER_OPTIONS = {
  crescent: (allWishlistProducts: TProduct[]): TProduct[] =>
    allWishlistProducts.sort((previousProduct, nextProduct) =>
      previousProduct.name.localeCompare(nextProduct.name)
    ),
  decrescent: (allWishlistProducts: TProduct[]): TProduct[] =>
    allWishlistProducts.sort((previousProduct, nextProduct) =>
      nextProduct.name.localeCompare(previousProduct.name)
    ),
  biggestValue: (allWishlistProducts: TProduct[]): TProduct[] =>
    allWishlistProducts.sort(
      (previousProduct, nextProduct) =>
        nextProduct.buyBox[0].price.inCash - previousProduct.buyBox[0].price.inCash
    ),
  lowestValue: (allWishlistProducts: TProduct[]): TProduct[] =>
    allWishlistProducts.sort(
      (previousProduct, nextProduct) =>
        previousProduct.buyBox[0].price.inCash - nextProduct.buyBox[0].price.inCash
    ),
};
